// extracted by mini-css-extract-plugin
module.exports = {"paper":"AOSalesView_paper__3Iko6","logo":"AOSalesView_logo__2yGMq","label":"AOSalesView_label__-t9je"};